import { RepositoriesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { repositoriesKeys } from 'app/queries/repositories/repositoriesKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof repositoriesKeys.slugAvailability>>;

export const createFetchRepositorySlugAvailabilityQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() => cancelOnSignal(RepositoriesService.isRepositorySlugAvailable(params), signal));
